package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class DashboardMetrics(
    val totalUsers: Long,
    val totalAccounts: Long
)
